import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容栏目",
    links: [
      { label: "漫画排行榜", to: "/rank" },
      { label: "编辑推荐", to: "/recommend" },
      { label: "精选书单", to: "/booklist" },
      { label: "社区讨论", to: "/discussion" },
    ],
  },
  {
    title: "站内导航",
    links: [
      { label: "首页", to: "/" },
      { label: "人气榜单", to: "/rank" },
      { label: "新作速递", to: "/recommend" },
      { label: "话题广场", to: "/discussion" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-700 text-secondary-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 font-heading text-lg text-background-50">笨</span>
              <span className="font-heading text-2xl text-background-50">笨狗漫画网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-100">
              一站式漫画追更决策平台，汇集排行榜、编辑推荐、精选书单、社区讨论与评分，帮你看榜下单、追更不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-600 text-secondary-100">
                <i className="ri-wechat-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-600 text-secondary-100">
                <i className="ri-weibo-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-600 text-secondary-100">
                <i className="ri-bilibili-line text-lg" aria-hidden="true"></i>
              </span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-lg text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-100 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-2 border-t border-secondary-600 pt-6 sm:flex-row sm:justify-between">
          <p className="text-xs text-secondary-200">
            © {new Date().getFullYear()} 笨狗漫画网 版权所有 · 仅供内容展示
          </p>
          <p className="text-xs text-secondary-200">联系邮箱：hello@bengou-manga.example.com</p>
        </div>
      </div>
    </footer>
  );
}